<script setup>

</script>

<template>

  <svg fill="none" height="15" viewBox="0 0 14 8" width="28" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M13 4.76929C13.2761 4.76929 13.5 4.54543 13.5 4.26929C13.5 3.99314 13.2761 3.76929 13 3.76929L13 4.76929ZM0.366417 3.91573C0.171155 4.11099 0.171155 4.42758 0.366417 4.62284L3.5484 7.80482C3.74366 8.00008 4.06024 8.00008 4.2555 7.80482C4.45077 7.60956 4.45077 7.29298 4.2555 7.09771L1.42708 4.26929L4.2555 1.44086C4.45077 1.2456 4.45077 0.929015 4.2555 0.733752C4.06024 0.53849 3.74366 0.53849 3.5484 0.733752L0.366417 3.91573ZM13 3.76929L0.719971 3.76929L0.719971 4.76929L13 4.76929L13 3.76929Z"
        fill="white"/>
  </svg>


</template>

<style lang="scss" scoped>

</style>